// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__5UjFs","file":"styles_file__3v639"};